/**
 * Native AR/AP service (#20, 2026-07-06) — the /finance/ar and /finance/ap
 * screens read OUR OWN document ledgers (customer_invoices / supplier_invoices)
 * via /api/accounting/native/*. Response shapes mirror the old quickbooksService
 * functions field-for-field, so the screens' rendering is unchanged. The QB
 * endpoints still exist for other consumers — switching back is an import swap.
 */
import api from '../config/api';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.superchargeme.com';

export const getEntities = async () => {
  const response = await api.get(`${API_BASE}/api/accounting/native/entities`);
  return response.data;
};

export const getARAgingSummary = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ar/aging`, { params });
  return response.data;
};

export const getOutstandingInvoices = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ar/invoices/outstanding`, { params });
  return response.data;
};

export const getCustomerBalances = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ar/customers/balances`, { params });
  return response.data;
};

export const getProcessorBalances = async () => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ar/processor-balances`);
  return response.data;
};

export const getAPAgingSummary = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ap/aging`, { params });
  return response.data;
};

export const getOutstandingBills = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ap/bills/outstanding`, { params });
  return response.data;
};

export const getVendorBalances = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/accounting/native/ap/vendors/balances`, { params });
  return response.data;
};

export default {
  getEntities,
  getARAgingSummary,
  getOutstandingInvoices,
  getCustomerBalances,
  getProcessorBalances,
  getAPAgingSummary,
  getOutstandingBills,
  getVendorBalances,
};
